import { useFormContext, useWatch } from 'react-hook-form';
import { Button } from '@app/_components/button';
import { Box } from '@styled-system/jsx';
import { Spinner } from './spinner';
import type { PostCommentFormData } from './type';

export const SendButton = () => {
  const { formState } = useFormContext();
  const text = useWatch<PostCommentFormData>({ name: 'commentText' });
  const isDisabled = formState.isSubmitting || !text;

  return (
    <Box w="60px" position="relative">
      <Button
        type="pill"
        size="small"
        fontSize="size_14"
        w="60px"
        h="36px"
        lineHeight="1"
        mb="2px"
        disabled={isDisabled}
      >
        {formState.isSubmitting ? <Spinner /> : <>送信</>}
      </Button>
    </Box>
  );
};
